import { ButtonGhostV2, ButtonPrimaryV2, ButtonSecondaryV2, ButtonTertiaryV2, colors2, getBreakPoint, useHandleClickOutside, useScreenWidth } from "oolib";
import React, { useState, useRef } from "react";
import { useGetQueryData } from "../../../../../../../utils/react-query-hooks/general";
import { useUpdateNotifIsRead } from "../../../../../../../utils/react-query-hooks/notifications";
import OkeBell from "../../../../../../icons/New/OkeBell";
import { NotificationBox } from "./comps";
import { NotificationButtonStyled } from "./styled";

// const user = {
//     notifications: [
//       {
//         kp_msg_desc:
//           "Your story "Indias Daughter" Has been posted in the story section",
//         kp_isRead: false,
//         kp_link: "/published-page/caseReports?id=6172993e13cd9d000ac24b48",
//         kp_date: new Date("2022-08-25T06:20:25.238+00:00"),
//       },
//       {
//         kp_msg_desc:
//           "Your story "Indias Daughter" Has been posted in the story section",
//         kp_isRead: true,
//         kp_link: "/published-page/caseReports?id=6172993e13cd9d000ac24b48",
//         kp_date: new Date("2022-08-25T06:20:25.238+00:00"),
//       },
//       {
//         kp_msg_desc:
//           "Your story "Indias Daughter" Has been posted in the story section",
//         kp_isRead: false,
//         kp_link: "/published-page/caseReports?id=6172993e13cd9d000ac24b48",
//         kp_date: new Date("2022-08-24T06:20:25.238+00:00"),
//       },
//       {
//         kp_msg_desc:
//           "Your story "Indias Daughter" Has been posted in the story section",
//         kp_isRead: true,
//         kp_link: "/published-page/caseReports?id=6172993e13cd9d000ac24b48",
//         kp_date: new Date("2022-08-24T06:20:25.238+00:00"),
//       },
//       {
//         kp_msg_desc:
//           "Your story "Indias Daughter" Has been posted in the story section",
//         kp_isRead: false,
//         kp_link: "/published-page/caseReports?id=6172993e13cd9d000ac24b48",
//         kp_date: new Date("2022-08-23T06:20:25.238+00:00"),
//       },
//       {
//         kp_msg_desc:
//           "Your story "Indias Daughter" Has been posted in the story section",
//         kp_isRead: true,
//         kp_link: "/published-page/caseReports?id=6172993e13cd9d000ac24b48",
//         kp_date: new Date("2022-08-23T06:20:25.238+00:00"),
//       },
//       {
//         kp_msg_desc:
//           "Your story "Indias Daughter" Has been posted in the story section",
//         kp_isRead: true,
//         kp_link: "/published-page/caseReports?id=6172993e13cd9d000ac24b48",
//         kp_date: new Date("2022-07-23T06:20:25.238+00:00"),
//       },
//     ],
//   };

export default function MyNotifications({ isSmallScreen }) {
  const { user } = useGetQueryData("userData") || {};

  const updateNotifIsRead = useUpdateNotifIsRead();
  const [open, setOpen] = useState(false);
  const notifDdRef = useRef(null);
  const screenWidth = useScreenWidth()

  useHandleClickOutside(notifDdRef, setOpen);

  const getTotUnreadNotifs = (notifData) => {
    return notifData.filter((d) => d.kp_isRead === false).length;
  };

  const handleOnClick = () => {
    if (
      !open &&
      user &&
      user.notifications.some((d) => d.kp_isRead === false)
    ) {
      updateNotifIsRead.mutate({ userId: user._id });
    }

    setOpen((prev) => !prev);
  };
  

  const totUnreadNotifsLength = user && getTotUnreadNotifs(user.notifications)
  const ButtonComp = (totUnreadNotifsLength && !isSmallScreen) ? ButtonSecondaryV2 : isSmallScreen ? ButtonTertiaryV2 : ButtonGhostV2

  return (
    <div ref={notifDdRef} style={{ position: "relative" }}>
      <ButtonComp 
        icon="Bell"
        responsive
        iconSize={isSmallScreen ? 20 : 16} 
        onClick={handleOnClick}
        children={!isSmallScreen && totUnreadNotifsLength}
        style={{ 
          borderRadius: "3.7rem", 
          padding: isSmallScreen ? "1.2rem" : "0.9rem",
          paddingLeft: isSmallScreen ? "1.2rem" : "1.4rem", 
          paddingRight: isSmallScreen ? "1.2rem" : "1.4rem", 
        }}
      />
      {/* Green dot for mobile */}
      {(totUnreadNotifsLength && isSmallScreen) ? (
        <span
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            width: "12px",
            height: "12px",
            background: "#4CAF0C",
            borderRadius: "50%",
            border: "2px solid white",
            zIndex: 2,
            display: "block",
          }}
        />
      ): null}
      {open && (
        <NotificationBox
          data={user && user.notifications}
          onClick={() => setOpen(false)}
        />
      )}
    </div>
  );
}
